export default {
  data() {
    return {
      items: [],
      itemIds: [],
      allItems: false,
    };
  },
  watch: {
    downloads(val, oldVal) {
      if (val !== oldVal) {
        this.initItems(val);
      }
    },
    allItems(val, oldVal) {
      if (val !== oldVal) {
        this.items.map((item) => {
          return item.selected = val;
        });
      }

      this.handleSelect();
    },
  },
  methods: {
    initItems(items) {
      items.forEach((item) => {
        item.selected = false;
        item.disabled = !parseInt(item.ready_for_download);

        this.items.push(item);
      });
    },
    handleSelect() {
      this.itemIds = [];
      this.items.forEach((item) => {
        if (item.selected) {
          this.itemIds.push(item.id);
        }
      });
    },
    async handleMultiDownload(type) {
      const loader = this.$loading.show();
      let itemIds = [];

      if (type === 'all') {
        this.items.forEach((item) => itemIds.push(item.id));
      } else {
        itemIds = this.itemIds;
      }

      try {
        const response = await this.axios.post('orders/get_downloadable_items', {order_item_ids: itemIds});

        if (response.data.data.url) {
          window.location.assign(response.data.data.url);
        }

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    async handleDownload(index) {
      window.location.assign(
          `${process.env.VUE_APP_BASE_API_URL}orders/download_item/${this.items[index].order_id}/${this.items[index].id}`);
    },
  },
  created() {
    if (this.downloads) {
      this.initItems(this.downloads);
    } else {
      this.$store.dispatch('INIT_DOWNLOADS');
    }
  },
};
